import React, { useState } from "react";
import { Button, Tooltip, makeStyles } from "@material-ui/core";

import { DataGrid } from "@material-ui/data-grid";

import ReportFilter from "./ReportFilter";
import ReportLayoutPage from "./ReportLayoutPage";

import { usePreference } from "../common/preferences";

import { showLoaderStateActions } from "../store";

import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  tContainer: {
    maxHeight: 690,
  },
}));

/* ================= FILTER ================= */

const Filter = ({ setItems }) => {
  const dispatch = useDispatch();

  const userID = usePreference("id");

  const handleSubmit = async (deviceId, groupId, from, to, mail, headers) => {
    const query = new URLSearchParams({
      userId: userID,

      from,

      to,

      actionBy: false,

      mail: false,
    });

    dispatch(showLoaderStateActions.addState(true));

    try {
      /* ✅ ONLY URL CHANGED */

      const response = await fetch(
        `/api/paymentGatewayVendorAccountRechargeOrder/getTransactions?userId=${userID}&${query.toString()}`,

        { headers },
      );

      if (!response.ok) {
        dispatch(showLoaderStateActions.addState(false));

        return;
      }

      const data = await response.json();

      dispatch(showLoaderStateActions.addState(false));

      setItems(data);
    } catch (error) {
      dispatch(showLoaderStateActions.addState(false));

      console.error(error);
    }
  };

  return (
    <ReportFilter
      handleSubmit={handleSubmit}
      reportHeader="Account Transaction Report"
      showOnly={true}
    />
  );
};

/* ================= MAIN PAGE ================= */

const OnlineAccountTransactionsReportPage = () => {
  const classes = useStyles();

  const [items, setItems] = useState([]);

  let mainData = [];

  const setRecursiveData = (newItems) => {
    setTimeout(() => {
      let hasMore = mainData.length + 1 < newItems.length;

      const list = newItems.slice(0, mainData.length + 1);

      mainData = list;

      setItems(list);

      if (hasMore) setRecursiveData(newItems);
    }, 0);
  };

  const setData = (newItems) => {
    mainData = [];

    setRecursiveData(newItems);
  };

  /* SAME COLUMNS */

  const columns = [
    {
      field: "date",

      headerName: "Date",

      width: 180,
    },

    {
      field: "status",

      headerName: "Transaction Status",

      width: 180,
    },

    {
      field: "amount",

      headerName: "Total Amount",

      width: 160,
    },

    {
      field: "reference",

      headerName: "Reference Number",

      width: 220,
    },

    {
      field: "transaction",

      headerName: "Transaction Number",

      width: 220,
    },

    {
      field: "error",

      headerName: "Error",

      width: 200,
    },

    {
      field: "invoiceNumber",

      headerName: "Invoice Number",

      width: 180,
    },

    {
      field: "download",

      headerName: "Download Invoice",

      width: 180,

      renderCell: (params) => {
        const hasInvoice = !!params.row.invoiceUrl;

        return (
          <Tooltip
            title={hasInvoice ? "Download Invoice" : "No Invoice Available"}
          >
            <span>
              <Button
                variant="outlined"
                color="primary"
                size="small"
                disabled={!hasInvoice}
                onClick={() => {
                  window.open(params.row.invoiceUrl, "_blank");
                }}
              >
                Download
              </Button>
            </span>
          </Tooltip>
        );
      },
    },
  ];

  /* SAME ROW MAPPING (Adjusted for amount API) */

  const gridRows = items.map((item) => ({
    id: item.id,
    date: new Date(item.createdAt).toLocaleString(),
    status: item.txnStatus,
    amount: item.totalOrderAmount,
    reference: item.referenceId,
    transaction: item.transactionNumber,
    error: item.errorMessage || "-",
    invoiceNumber: item.zohoBooksInvoiceNumber || "-",
    invoiceUrl: item.zohoBooksInvoiceUrl,
  }));

  return (
    <ReportLayoutPage filter={<Filter setItems={setData} />}>
      <DataGrid
        rows={gridRows}
        columns={columns}
        disableSelectionOnClick
        autoHeight={false}
        pageSize={50}
        rowsPerPageOptions={[50, 100, 500]}
        style={{
          height: "85vh",

          width: "100%",

          backgroundColor: "white",
        }}
        pagination
      />
    </ReportLayoutPage>
  );
};

export default OnlineAccountTransactionsReportPage;
